import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { DiningGuideOldComponent } from './dining-guide-old.component';
import { DiningGuideComponent } from './dining-guide.component';
import { DiningGuideRegionComponent } from './dining-guide-region.component';

const routes: Routes = [
  {
    path: 'dining-guide-old',
    component: DiningGuideOldComponent,
    pathMatch: 'full'
  },
  {
    path: 'dining-guide',
    component: DiningGuideComponent,
    pathMatch: 'full'
  },
  {
    path: 'dining-guide-region/:friendlyUrl',
    component: DiningGuideRegionComponent
  }

];

export const routing = RouterModule.forRoot(routes);

//@NgModule({
//  imports: [RouterModule.forRoot(routes)],
//  exports: [RouterModule]
//})
//export class AppRoutingModule { }
